export default {
      id: "info_questions-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#info_questions",
      toString: function () {
        return this.url;
      }
    }